import { useTranslation } from 'react-i18next';

import { SubscriberResponseDto } from 'theSource/types';

interface WelcomeProps {
  subscriber?: SubscriberResponseDto;
}

export const Welcome = ({ subscriber }: WelcomeProps) => {
  const { t } = useTranslation('pages.home');
  const firstName = subscriber?.data.first_name.value;

  const welcomeHeader = t('welcome', { firstName: firstName });
  const welcomeText = t('welcomeNew');

  return (
    <div>
      <h1>
        {welcomeHeader}
        <span className="sr-only"> {t('title')}</span>
      </h1>
      <p>{welcomeText}</p>
    </div>
  );
};
